import React, { useState } from 'react';
import { toast, ToastContainer, Slide } from 'react-toastify';
import { TableContainer } from '../common';
import { get } from '../../utils/network';
import { downloadDocumentTypesJsonFile } from '../../utils/downloadFiles';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../utils/config';

export const MESSAGES = {
    title: 'Listado de tipo de documentos',
    created: 'El tipo de documento ha sido creado correctamente',
    edited: 'El tipo de documento ha sido editado correctamente',
    deleted: 'El tipo de documento ha sido eliminado correctamente',
    importSuccess: 'Se han importado los tipos de documento correctamente',
    deleteConfirmation: document =>
        `¿Estas seguro de que queres eliminar el tipo de documento ${document.documentType}?`,
};

const COLUMNS = [
    {
        id: 'documentType',
        label: 'Tipo de documento',
        minWidth: 100,
        hidden: {
            xsDown: true,
        },
    },
        {
        id: 'description',
        label: 'Descripción',
        minWidth: 100,
        hidden: {
            xsDown: true,
        },
    },
    {
        id: 'identifier',
        label: 'Identificador',
        minWidth: 100,
        hidden: {
            xsDown: true,
        },
    },
    {
        id: 'aggregator',
        label: 'Agrupador',
        minWidth: 100,
        hidden: {
            xsDown: true,
        },
    },

];

export const ENTITY_PROPS = {
    entityName: 'tipo de documento',
    endpoint: 'documentTypes',
    path: '/home/documentTypes',
};

const DocumentTable = () => {

    const [ filter, setFilter ] = useState(null)

    const searchFilter = (row, word) => {
        const lowercaseWord = word.toLowerCase()
        setFilter(lowercaseWord)
        return row.documentType.toLowerCase().includes(lowercaseWord) ||
               row.description.toLowerCase().includes(lowercaseWord)
    }

    const toastNotification = () => {
        toast.success('Exportación finalizada', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
            toastId: "documentTypesExportSuccess"
        });
    }

    const handleExport = async (data, id, description) => {
        toast.info('⬇️ Exportando tipos de documento', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
            toastId: "documentTypesExporting"
        })

        let url = "documentTypes/export/json"
        let file_name = "Tipos de documento"

        if (id && description) {
            url = `documentTypes/${id}/export/json`
            file_name = description
        }

        if (filter && data.length > 0) {
            url += `?filter=${filter}`
        }
        
        get(url)
            .then((res) => res.json())
            .then((data) => {
                const jsonString = JSON.stringify(data, null, 2);
                const jsonBlob = new Blob([jsonString], { type: 'application/json' });
                const url = (window.URL ? window.URL : window.webkitURL).createObjectURL(jsonBlob);
                file_name += " - " + new Date().toISOString() + ".json";
                downloadDocumentTypesJsonFile(url, file_name);
            })
            .then(() => {
                toastNotification();
            });
    };

    const handleCopyCurl = (data) => {
        if (data && data.schema && data.documentType ){
    
          const jsonData = JSON.parse(data.schema).properties
          let cUrl = `curl -X POST -H "Authorization: Bearer <<token>>" ${config.backEndUrl} -F "document=@<<archivo>>" -F "type=${data.documentType}" `
    
    
          for (const [key, value] of Object.entries(jsonData)) {
            if (key !== 'type') {
              cUrl += ` -F "${key}=<<metadata>>" `
            }
          }
          navigator.clipboard.writeText(cUrl)
    
          toast.success('cUrl copiado al portapapeles!', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            transition: Slide,
          });
        } else {
          toast.error('No se pudo copiar el cUrl', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            transition: Slide,
          });
        }
      }

    return (
        <div>
            <TableContainer 
                dataCount={3} entityProps={ENTITY_PROPS} messages={MESSAGES}
                columns={COLUMNS} prefetchAllPages={true}
                searchEnabled={true} searchFilter={searchFilter} enableDuplicate={true}
                importExportEnabled={true} onExport={handleExport} enableShare={true} handleCopyCurl={handleCopyCurl}/>
            <ToastContainer/>
        </div>
    );
};

export default DocumentTable;
